import { useClientsByUnresolvedNotificationsQuery } from "@graphql/clients/clients.g";
import { BarDatum } from "@nivo/bar";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router";

import { BarChart } from "@design-system/BarChart/BarChart";

import { routes } from "@pages/routes";

export const TopUnresolvedNotificationsChart = () => {
  const navigate = useNavigate();
  const clientsByUnresolvedNotificationsQuery =
    useClientsByUnresolvedNotificationsQuery();

  const handleDetailsClick = useCallback(
    (clientId: string) => {
      navigate(
        routes.portal.clients.client.notifications.$buildPath({
          params: { clientId },
        }),
        {
          viewTransition: true,
        },
      );
    },
    [navigate],
  );

  const clientsWithNotifications: BarDatum[] = useMemo(() => {
    const received_data =
      clientsByUnresolvedNotificationsQuery.data?.clients?.edges
        .map((client) => ({
          id: client?.node?.id || "",
          client: client?.node?.name || "Unknown Tenant",
          SHARED_LOGIN: (
            client?.node?.notifications?.aggregate?.groupBy?.notificationGroups?.filter(
              (notificationGroup) =>
                notificationGroup?.notificationType === "SHARED_LOGIN",
            )[0]?.count || 0
          ).toString(),
          SAAS_DISCOVERED: (
            client?.node?.notifications?.aggregate?.groupBy?.notificationGroups?.filter(
              (notificationGroup) =>
                notificationGroup?.notificationType === "SAAS_DISCOVERED",
            )[0]?.count || 0
          ).toString(),
        }))
        .filter(
          (client) =>
            Number(client.SHARED_LOGIN) > 0 ||
            Number(client.SAAS_DISCOVERED) > 0,
        );
    if (!received_data) return [];
    return received_data;
  }, [clientsByUnresolvedNotificationsQuery.data]);

  return (
    <BarChart
      chartData={clientsWithNotifications}
      onDetailsClick={(clientRecord: BarDatum) =>
        handleDetailsClick(clientRecord.id.toString())
      }
      keyMap={{
        SHARED_LOGIN: "Shared login",
        SAAS_DISCOVERED: "Unreviewed app",
      }}
    />
  );
};
